import { useState } from 'react'
import { GoogleLogin } from '@react-oauth/google'
import { useAuth } from '../../contexts/AuthContext'

export default function LoginPage() {
  const { loginWithGoogle } = useAuth()
  const [signingIn, setSigningIn] = useState(false)

  const handleGoogleSuccess = async (credentialResponse: any) => {
    if (!credentialResponse.credential) return
    setSigningIn(true)
    try {
      await loginWithGoogle(credentialResponse.credential)
    } catch {
      // toast is already shown by AuthContext
    } finally {
      setSigningIn(false)
    }
  }

  const handleGoogleError = () => {
    console.error('Google Sign-In failed')
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--bk-hero-grad, var(--bk-bg))',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <div style={{ width: '100%', maxWidth: 420, display: 'flex', flexDirection: 'column', gap: 20 }}>
        {/* Header */}
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
          <img
            src="/images/bk-profile-logo.png"
            alt="BK Profiles"
            style={{ width: 300, height: 300, objectFit: 'contain' }}
          />
          <div>
            <h1
              className="bk-display"
              style={{
                fontFamily: 'var(--bk-font-display)',
                fontSize: 32,
                fontWeight: 500,
                color: 'var(--bk-ink)',
                letterSpacing: 'var(--bk-display-tracking)',
                margin: 0,
              }}
            >
              BK Profiles
            </h1>
            <p style={{ marginTop: 6, color: 'var(--bk-muted)', fontSize: 13 }}>
              Welcome back — sign in to continue
            </p>
          </div>
        </div>

        {/* Card */}
        <div
          className="bk-card"
          style={{
            background: 'var(--bk-surface)',
            border: '1px solid var(--bk-border)',
            borderRadius: 'var(--bk-radius-lg)',
            boxShadow: 'var(--bk-shadow-2)',
            padding: '28px 24px',
            display: 'flex',
            flexDirection: 'column',
            gap: 18,
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--bk-ink)' }}>
              Sign in with Google
            </div>
            <div style={{ fontSize: 12, color: 'var(--bk-muted)', marginTop: 4 }}>
              Use your authorised Google account
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {signingIn ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  color: 'var(--bk-muted)',
                  fontSize: 13,
                  padding: '8px 0',
                }}
              >
                <svg className="animate-spin" style={{ height: 18, width: 18, color: 'var(--bk-accent)' }} viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" opacity="0.25"></circle>
                  <path fill="currentColor" opacity="0.75" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                </svg>
                Signing you in…
              </div>
            ) : (
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={handleGoogleError}
                useOneTap={false}
                theme="outline"
                size="large"
                text="signin_with"
                shape="rectangular"
                logo_alignment="center"
                width={320}
              />
            )}
          </div>

          <p style={{ textAlign: 'center', fontSize: 11.5, color: 'var(--bk-muted)', margin: 0 }}>
            If you need access, please contact your administrator.
          </p>
        </div>

        <p style={{ textAlign: 'center', fontSize: 11, color: 'var(--bk-faint)', margin: 0 }}>
          © 2026 Brahma Kumaris. All rights reserved.
        </p>
      </div>
    </div>
  )
}
